import React, { useCallback, useEffect } from 'react';
import { richMessageUtil } from 'src/utils/RichMessageUtil';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import CloseableMessageComponent from 'src/components/CloseableMessageComponent';
import { loadProgressBar } from 'axios-progress-bar';
import { headerHideAction } from './actions/HeaderActions';

import 'axios-progress-bar/dist/nprogress.css';
import './HeaderContainer.scss';

const HeaderContainer = () => {
    const { headerMessages } = useSelector((state) => state.HeaderReducer, shallowEqual);

    const dispatch = useDispatch();

    useEffect(() => {
        loadProgressBar();
    }, []);

    const headerMessagesCloseHandler = useCallback(() => {
        dispatch(headerHideAction());
    }, [
        dispatch,
    ]);

    // in case there is only one message
    const messages = Array.isArray(headerMessages) ? headerMessages : [
        headerMessages,
    ];

    const messageList = messages.map((message) => {
        const richHeaderMessages = richMessageUtil(message);
        return (
            <div
                key={richHeaderMessages}
                className="pt-3 pb-3"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                }}
            >
                <CloseableMessageComponent
                    message={richHeaderMessages}
                    onClose={headerMessagesCloseHandler}
                />
            </div>
        );
    });

    return messageList.length ? messageList : null;
};

HeaderContainer.propTypes = {

};

export default HeaderContainer;
